import { MenuItem, Select, Stack, TextField } from "@mui/material"
import { useState } from "react"
import Modal from "../ui/Modal"
import FormItem from "../ui/FormItem"
import { createChannel } from "../../api"
import { useSnackbar } from "notistack"

const options = ["LOW", "HIGH", "MEDIUM"]

const AddChannel = (props) => {
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)

  const [data, setData] = useState({
    name: "",
    priority: "LOW",
    batchIds: [],
    userIds: [],
  })

  const handleChange = (event) => {
    const { name, value } = event.target
    setData({
      ...data,
      [name]: value,
    })
  }

  const handleSubmit = () => {
    setLoading(true)
    createChannel(data)
      .then(() => {
        enqueueSnackbar("Channel added.", { variant: "success" })
        props.close()
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  return (
    <Modal
      {...props}
      title="Add Channel"
      actionText={"Add"}
      action={handleSubmit}
      loading={loading}
    >
      <Stack>
        <Stack direction={"column"} spacing={2} alignItems="center">
          <FormItem label="Name">
            <TextField name="name" value={data.name} onChange={handleChange} />
          </FormItem>
          <FormItem label="Channel">
            <Select
              name="priority"
              value={data.priority}
              onChange={handleChange}
            >
              {options.map((c) => (
                <MenuItem value={c}>{c}</MenuItem>
              ))}
            </Select>
          </FormItem>
        </Stack>
      </Stack>
    </Modal>
  )
}

export default AddChannel
